export default function FourOFour() {
    return (
      <div>
        <h1>Sorry, no page found</h1>
      </div>
    );
  }